import React, { useEffect, useRef } from "react"
import { Container, useDialogActions, useDialogState } from "@hg/dialog-sdk"
import { dialogBackgrounds, characterNames } from "../config"

import { DialogContent } from "./DialogContent"
import { DialogBackdrop } from "./DialogBackdrop"
import { DialogSkill } from "./DialogSkill"
import { nameMap } from "../config/resources"

import styles from "./index.module.scss"
import { DialogueData } from "../types"

export const DialogManagerWrapper: React.FC = () => {
    const actions = useDialogActions()
    const state = useDialogState()

    const guideKey =
        (state.currentDialogue as DialogueData)?.guideKey || undefined
    const highlight = state.currentDialogue?.highlight || "none"

    const type = (state.currentDialogue as DialogueData)?.type || "normal"

    // 监听对话变化，执行 onShow 回调
    useEffect(() => {
        const currentDialogue = state.currentDialogue as
            | DialogueData
            | undefined
        if (!currentDialogue?.onShow) {
            return
        }

        // 执行回调
        currentDialogue.onShow()
    }, [state.currentDialogue])

    // 获取当前说话者
    const currentSpeaker = state.currentDialogue?.speaker || ""
    const speakerKey = currentSpeaker || nameMap.nian

    // 获取当前背景图片
    const backgroundImage = dialogBackgrounds.common
    const nameImages = characterNames[speakerKey as keyof typeof characterNames]

    const text = state.currentDialogue?.text || ""

    return (
        <Container.Root
            className={styles.container}
            onClick={() => {
                actions.handleClick()
            }}
        >
            <DialogBackdrop guideKey={guideKey}>
                {type === "guideSkill" && <DialogSkill text={text} />}
            </DialogBackdrop>

            {type !== "guideSkill" && (
                <DialogContent
                    type={type}
                    highlight={highlight}
                    backgroundImage={backgroundImage}
                    nameImages={nameImages}
                />
            )}
        </Container.Root>
    )
}
